import React from 'react';

export default function AboutUsPage({ isAuthenticated }) {
  return (
    <div>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%)',
        color: 'white',
        padding: 'var(--spacing-16) 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ fontSize: 'var(--font-size-4xl)', marginBottom: 'var(--spacing-6)' }}>
            About GradedWash
          </h1>
          <p style={{ 
            fontSize: 'var(--font-size-xl)', 
            maxWidth: '800px',
            margin: '0 auto',
            color: 'white',
            fontWeight: '500',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
          }}>
            We're revolutionizing travel by connecting people based on personality compatibility, 
            making every journey safer, more enjoyable, and truly memorable.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="p-6">
        <div className="container">
          <div className="row">
            <div className="col col--8" style={{ margin: '0 auto' }}>
              <div className="card p-6">
                <h2 className="text-center m-6">Our Mission</h2>
                <p style={{ fontSize: 'var(--font-size-lg)', lineHeight: 1.7, textAlign: 'center' }}>
                  At GradedWash, we believe that travel is better when shared with the right people. 
                  Our mission is to connect travelers based on personality compatibility, ensuring 
                  every journey is safer, more enjoyable, and truly memorable. You get the chance to 
                  select matched personalities to yourself for possible meetups. Just sign up for free 
                  and take our personality matching test and start to find others of like minds to share 
                  a travel experience with and invite your friends to find discounted travel deals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety in Numbers Section */}
      <section className="bg-light p-6">
        <div className="container">
          <div className="row align-center">
            <div className="col col--6">
              <h2>Safety in Numbers</h2>
              <p style={{ fontSize: 'var(--font-size-lg)', lineHeight: 1.6, marginBottom: 'var(--spacing-6)' }}>
                Traveling alone can be risky, but with a matched companion, you have someone 
                to watch your back, share experiences with, and navigate unfamiliar places together. 
                Our personality matching ensures you're paired with someone who shares your values 
                and travel style, creating a safer environment for both of you.
              </p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li className="d-flex align-center" style={{ marginBottom: 'var(--spacing-3)' }}>
                  <span className="bg-success text-white" style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'var(--font-size-sm)',
                    marginRight: 'var(--spacing-3)'
                  }}>✓</span>
                  Shared responsibility for navigation and planning
                </li>
                <li className="d-flex align-center" style={{ marginBottom: 'var(--spacing-3)' }}>
                  <span className="bg-success text-white" style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'var(--font-size-sm)',
                    marginRight: 'var(--spacing-3)'
                  }}>✓</span>
                  Someone to help in emergency situations
                </li>
                <li className="d-flex align-center" style={{ marginBottom: 'var(--spacing-3)' }}>
                  <span className="bg-success text-white" style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'var(--font-size-sm)',
                    marginRight: 'var(--spacing-3)'
                  }}>✓</span>
                  Reduced risk of being targeted as a solo traveler
                </li>
                <li className="d-flex align-center" style={{ marginBottom: 'var(--spacing-3)' }}>
                  <span className="bg-success text-white" style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'var(--font-size-sm)',
                    marginRight: 'var(--spacing-3)'
                  }}>✓</span>
                  Shared costs for accommodation and transportation
                </li>
                <li className="d-flex align-center" style={{ marginBottom: 'var(--spacing-3)' }}>
                  <span className="bg-success text-white" style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 'var(--font-size-sm)',
                    marginRight: 'var(--spacing-3)'
                  }}>✓</span>
                  Built-in accountability and safety checks
                </li>
              </ul>
            </div>
            <div className="col col--6">
              <img 
                src="/happyfolks.svg" 
                alt="Happy people together" 
                style={{
                  width: '100%',
                  borderRadius: 'var(--radius-lg)',
                  boxShadow: 'var(--shadow-lg)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="p-6">
        <div className="container">
          <h2 className="text-center m-6">How It Works</h2>
          <div className="row">
            <div className="col col--4">
              <div className="card text-center p-6">
                <div className="bg-primary text-white" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto var(--spacing-4)',
                  fontSize: 'var(--font-size-2xl)'
                }}>
                  1
                </div>
                <h3>Sign Up & Take Quiz</h3>
                <p className="text-muted">
                  Create your profile and complete our comprehensive personality assessment 
                  to understand your travel preferences and style.
                </p>
              </div>
            </div>
            
            <div className="col col--4">
              <div className="card text-center p-6">
                <div className="bg-success text-white" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto var(--spacing-4)',
                  fontSize: 'var(--font-size-2xl)'
                }}>
                  2
                </div>
                <h3>Get Matched</h3>
                <p className="text-muted">
                  Our advanced algorithm analyzes your personality and matches you with 
                  compatible travelers who share your interests and travel goals.
                </p>
              </div>
            </div>
            
            <div className="col col--4">
              <div className="card text-center p-6">
                <div className="bg-warning text-white" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto var(--spacing-4)',
                  fontSize: 'var(--font-size-2xl)'
                }}>
                  3
                </div>
                <h3>Connect & Travel</h3>
                <p className="text-muted">
                  Start conversations with your matches, plan trips together, and embark 
                  on unforgettable adventures with your perfect travel companion.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-light p-6">
        <div className="container text-center">
          <h2>Ready to Find Your Travel Companion?</h2>
          <p className="text-muted" style={{ marginBottom: 'var(--spacing-6)' }}>
            Join thousands of travelers who have found their perfect match on GradedWash.
          </p>
          {isAuthenticated ? (
            <a href="/feed" className="btn btn--primary btn--large">Find Matches</a>
          ) : (
            <a href="/signup" className="btn btn--primary btn--large">Get Started Today</a>
          )}
        </div>
      </section>
    </div>
  );
} 